import { MFAScope } from "../../components/mfa/mfa-bean";

export enum AppAuthenticatorResult {
  ACTIVATED = 'ACTIVATED',
  VERIFIED = 'VERIFIED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
}

export interface AppAuthenticatorActivateRequest {
  publicKey: string;
}

/** Stored in secure storage after App Authenticator activation. */
export interface AppAuthenticatorStoredCredential {
  userId: string;
  privateKey: string;
}

/** Payload delivered via push for App Authenticator login approval. */
export interface AppAuthenticatorPushApprovalPayload {
  amount: number | string | null;
  targetName: string | null;
  cardNumber: string | null;
  vizAliasType: string | null;
  vizAliasValue: string | null;
  currentStatus: string | null;
  newStatus: string | null;
  orderType: string | null;
  deviceName: string;
  location: string;
  latitude: number | null;
  longitude: number | null;
  timeStamp: string;
  tfaPassphrase: string;
  token?: string;
  scope: MFAScope;
  authTitle: string;
}

export interface GetActiveNotificationsRequest {
  deviceId: string;
  userId: string;
  timestamp: number;
}

export interface ActiveNotification {
  id: string;
  type: string;
  priority: number;
  requiresAuth: boolean;
  expiresAt: number;
  payload: {
    authInfo: string;
  };
}
